__turbopack_context__.v({
  "errorPage": "styles-module-scss-module__VUTIKW__errorPage",
  "errorPage__imageContainer": "styles-module-scss-module__VUTIKW__errorPage__imageContainer",
  "errorPage__messageContainer": "styles-module-scss-module__VUTIKW__errorPage__messageContainer",
  "errorPage__messageContainer_link": "styles-module-scss-module__VUTIKW__errorPage__messageContainer_link",
  "errorPage__messageContainer_message": "styles-module-scss-module__VUTIKW__errorPage__messageContainer_message",
});
